module.exports = "<div class=\"form-group col-sm-{{$ctrl.elementModel.width}} {{$ctrl.elementModel.customClassName}}\" ng-if=\"$ctrl.parentModel.recaptcha\">\n    <div ng-class=\"$ctrl.parentModel.labelsPosition == 'left' ? 'col-sm-12' : ''\">\n        <img alt=\"recaptcha\" src=\"/images/recaptcha.jpg\"/>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/cmsCore/Creator/SectionsLibrary/Sections/Form/CaptchaInput/captchaInput.html
// module id = 1250
// module chunks = 0